import Vue from 'vue';

Vue.filter('displayName', function (value) {
  if (!value) return '';
  return value.toString().replaceAll(' ', '_');
});